import styled from "styled-components";

export const GradientBackground = styled.div`
  background: linear-gradient(36deg, #ffc77d 15%, #f8cbff 85%);
  min-height: 100vh;
`;
